import { Pagination } from "@mui/material";
import LoadingComponent from "../loading";

const TableComponent = ({ title, columns, children, loading, last_page, page, onClickPagination, onClick, iconButton, button, onClick2, iconButton2, button2 }: { title: string, columns: any, children: JSX.Element, loading: boolean, last_page?: number, page?: number, onClickPagination?: any, onClick?: any, iconButton?: any, button?: string, onClick2?: any, iconButton2?: any, button2?: string }) => {

    return (
        <div className="row gx-5">
            <div className="col-xl-12 col-lg-12 mb-5">
                <div className="card card-raised h-100 overflow-hidden">
                    <div className="card card-raised h-100">
                        <div className="card-header bg-primary text-white">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="fw-500">{title}</div>
                                {
                                    button &&

                                    <div className="dropdown my-n2 me-n2">
                                        <button className="btn btn-text-white sm me-2 mdc-ripple-upgraded" type="button" onClick={onClick}>
                                            {
                                                iconButton &&

                                                <i className="material-icons leading-icon">{iconButton}</i>
                                            }
                                            {button}
                                        </button>
                                        {
                                            button2 &&

                                            <button className="btn btn-text-white sm me-2 mdc-ripple-upgraded" type="button" onClick={onClick2}>
                                                {
                                                    iconButton2 &&

                                                    <i className="material-icons leading-icon">{iconButton2}</i>
                                                }
                                                {button2}
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <tbody className="align-middle"></tbody>
                                <thead className="text-xs font-monospace">
                                    <tr>
                                        {
                                            columns.map((c: any, index: number) => {
                                                return (
                                                    <td key={index} className={'px-4 py-2 border-bottom-0 text-muted'}>{c}</td>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                {
                                    loading == false &&

                                    <tbody>
                                        {children}
                                    </tbody>
                                }
                            </table>
                        </div>
                        {
                            loading &&

                            <LoadingComponent />
                        }
                        {

                            last_page! > 0 &&

                            <div className="d-flex justify-content-center mt-4 mb-4">
                                <Pagination count={last_page} page={page} color="primary" onChange={onClickPagination} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default TableComponent;